import React from 'react';
import Reveal from './Reveal';

/**
 * PageHeader - shared hero block used across all content pages to keep
 * a consistent typographic rhythm and entry animation.
 */
const PageHeader = ({ eyebrow, title, intro }) => {
  return (
    <section className="pt-32 pb-16 px-6 lg:px-12">
      <div className="max-w-4xl mx-auto text-center">
        <Reveal variant="fade">
          <p className="text-[11px] tracking-[0.22em] uppercase text-neutral-500 mb-6">{eyebrow}</p>
        </Reveal>
        <Reveal delay={120} duration={1100}>
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-medium tracking-tight leading-[1.05]">
            {title}
          </h1>
        </Reveal>
        {intro && (
          <Reveal delay={260}>
            <p className="mt-8 text-[15px] md:text-base text-neutral-600 leading-relaxed max-w-2xl mx-auto">
              {intro}
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
};

export default PageHeader;
